export const COMMON_TIMEZONES = [
    { value: 'Pacific/Honolulu', label: 'Hawaii (HST)' },
    { value: 'America/Anchorage', label: 'Alaska (AKST)' },
    { value: 'America/Los_Angeles', label: 'Pacific (PST)' },
    { value: 'America/Denver', label: 'Mountain (MST)' },
    { value: 'America/Phoenix', label: 'Arizona (MST)' },
    { value: 'America/Chicago', label: 'Central (CST)' },
    { value: 'America/New_York', label: 'Eastern (EST)' },
    { value: 'America/Puerto_Rico', label: 'Atlantic (AST)' },
    { value: 'America/Halifax', label: 'Atlantic Canada' },
    { value: 'America/St_Johns', label: 'Newfoundland' },
    { value: 'America/Sao_Paulo', label: 'Brasilia' },
    { value: 'Atlantic/Reykjavik', label: 'Iceland (GMT)' },
    { value: 'Europe/London', label: 'London (GMT)' },
    { value: 'Europe/Paris', label: 'Central Europe (CET)' },
    { value: 'Europe/Berlin', label: 'Berlin (CET)' },
    { value: 'Europe/Helsinki', label: 'Eastern Europe (EET)' },
    { value: 'Europe/Moscow', label: 'Moscow (MSK)' },
    { value: 'Asia/Dubai', label: 'Dubai (GST)' },
    { value: 'Asia/Kolkata', label: 'India (IST)' },
    { value: 'Asia/Bangkok', label: 'Indochina (ICT)' },
    { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
    { value: 'Asia/Shanghai', label: 'China (CST)' },
    { value: 'Asia/Tokyo', label: 'Japan (JST)' },
    { value: 'Australia/Sydney', label: 'Sydney (AEST)' },
    { value: 'Australia/Adelaide', label: 'Adelaide (ACST)' },
    { value: 'Australia/Perth', label: 'Perth (AWST)' },
    { value: 'Pacific/Auckland', label: 'New Zealand (NZST)' },
]
